/**************************************************************************************************************
    For a list of available material design icons, see: https://fonts.google.com/icons?selected=Material+Icons

    Usage: <vetology-svg
        data-svg="<name of svg, as given in the svg array below>"
        data-width="<width>"  // sets the width of the svg element
        data-height="<height>"  // sets the height of the svg element
        data-color="<color>"  // sets the color of the svg, can be hex or named color
        data-viewbox="x y dx dy">  // sets the viewbox attribute of the svg element
    </vetology-svg>

    Example: <vetology-svg data-svg="species_canine" data-width="100" data-height="100"></vetology-svg>

    Note: The data-path attribute is required.  The data-width/height attribute is required if you want to see the svg.

    Edit this file to include the icons you want to use.  The icons are stored in the svg object/array.  The key
    is the data-svg attribute value that you will use in your <vetology-svg> element.  The value is the svg Name that you imported.  The svg file is fetched from the path.  The svg file is then parsed and the svg element is created.  The svg element is then appended to this element.  This element is then removed from the DOM.

**************************************************************************************************************/
import SpeciesAvian from '../../../../images/svg/species/Avian.svg';
import SpeciesAvianFull from '../../../../images/svg/species/Avian_full.svg';
import SpeciesCanine from '../../../../images/svg/species/Canine.svg';
import SpeciesCanineFull from '../../../../images/svg/species/Canine_full.svg';
import SpeciesEquine from '../../../../images/svg/species/Equine.svg';
import SpeciesEquineFull from '../../../../images/svg/species/Equine_full.svg';
import SpeciesExotic from '../../../../images/svg/species/Exotics.svg';
import SpeciesExoticFull from '../../../../images/svg/species/Exotics_full.svg';
import SpeciesFeline from '../../../../images/svg/species/Feline.svg';
import SpeciesFelineFull from '../../../../images/svg/species/Feline_full.svg';
import FileRestore from '../../../../images/svg/file-restore.svg';
import PaperPlane from '../../../../images/svg/paper-plane.svg';
import Radiology from '../../../../images/svg/radiology.svg';
import CaseShare from '../../../../images/svg/case-share.svg';
import Delete from '../../../../images/svg/delete.svg';
import VetologyLogo from '../../../../images/svg/logos/vetology-logo.svg';
import HomeCircle from '../../../../images/svg/home-circle.svg';
import PersonCircle from '../../../../images/svg/person-circle.svg';
import DogHouse from '../../../../images/svg/dog-house.svg';
import VetologyLogoBlack from '../../../../images/svg/logos/vetology-logo-black.svg';
import VetologyLogoWhite from '../../../../images/svg/logos/vetology-logo-white.svg';
import VetologyLogoBlue from '../../../../images/svg/logos/vetology-logo-blue.svg';
import RedSubmit from '../../../../images/svg/red_submit.svg';  
import WhiteSubmit from "../../../../images/svg/white_submit.svg"; 
import left_panel_open from '../../../../images/svg/left_panel_open.svg';
import left_panel_close from '../../../../images/svg/left_panel_close.svg';
import right_panel_open from '../../../../images/svg/right_panel_open.svg';
import right_panel_close from '../../../../images/svg/right_panel_close.svg';
import expansion_panels from '../../../../images/svg/expansion_panels.svg';
import clinical_notes from '../../../../images/svg/clinical_notes.svg';
import article from '../../../../images/svg/article.svg';
import work_history from '../../../../images/svg/work_history.svg';
import print from '../../../../images/svg/print.svg';
import thumbs_up_down from '../../../../images/svg/thumbs_up_down.svg';
import double_arrow_right from '../../../../images/svg/double_arrow_right_circle.svg';
import download_for_offline from '../../../../images/svg/download_for_offline.svg'; 
import documents from '../../../../images/svg/documents.svg';
import warning from '../../../../images/svg/warning.svg';
import dangerous from '../../../../images/svg/dangerous.svg';
import check from '../../../../images/svg/check.svg';
import arrow_right from '../../../../images/svg/arrow_right.svg';
import review_clipboard from '../../../../images/svg/review_clipboard.svg';
import circle from '../../../../images/svg/circle.svg';
import hourglass from '../../../../images/svg/hourglass.svg';
import visibility_off from '../../../../images/svg/visibility_off.svg';
import check_circle from '../../../../images/svg/check_circle.svg';
import stacks from '../../../../images/svg/stacks.svg';
import search from '../../../../images/svg/search.svg';


const svgs = {
    'species_canine': SpeciesCanine,
    'species_canine_full': SpeciesCanineFull,
    'species_feline': SpeciesFeline,
    'species_feline_full': SpeciesFelineFull,
    'species_equine': SpeciesEquine,
    'species_equine_full': SpeciesEquineFull,
    'species_avian': SpeciesAvian,
    'species_avian_full': SpeciesAvianFull,
    'species_exotic': SpeciesExotic,
    'species_exotic_full': SpeciesExoticFull,
    'file_restore': FileRestore,
    'paper_plane': PaperPlane,
    'radiology': Radiology,
    'case_share': CaseShare,
    'delete': Delete,
    'vetology_logo': VetologyLogo,
    'home_circle': HomeCircle,
    'person_circle': PersonCircle,
    'dog_house': DogHouse,
    'vetology_logo_black': VetologyLogoBlack,
    'vetology_logo_white': VetologyLogoWhite,
    'vetology_logo_blue': VetologyLogoBlue,
    'red_submit': RedSubmit,
    'white_submit': WhiteSubmit, 
    'left_panel_open': left_panel_open,
    'left_panel_close': left_panel_close,
    'right_panel_open': right_panel_open,
    'right_panel_close': right_panel_close,
    'expansion_panels': expansion_panels,
    'clinical_notes': clinical_notes,
    'article': article,
    'work_history': work_history,
    'print': print,
    'thumbs_up_down': thumbs_up_down,
    'double_arrow_right': double_arrow_right,
    'download_for_offline': download_for_offline,
    'documents': documents,
    'warning': warning,
    'dangerous': dangerous,
    'check': check,
    'arrow_right': arrow_right,
    'review_clipboard': review_clipboard,
    'circle': circle,
    'hourglass': hourglass,
    'visibility_off': visibility_off,
    'check_circle': check_circle,
    'stacks': stacks,
    'search': search
}


export class VetologySvg extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        if (this.initialized) {
            return;              // moving an element re-fires this; we self-replace, so once only
        }
        this.initialized = true;
        this.init();
    }

    init() {
        this.createPath();
    }

    createPath() {
        if (this.dataset.svg === undefined) {
            console.error('VetologySvg: Missing data-svg attribute');
            throw new Error('VetologySvg: Missing data-svg attribute');
        }

        const path = svgs[this.dataset.svg];
        fetch(path) // Get the contents of the SVG file
            .then(response => response.text())
            .then(svgData => {
                const svgContainer = document.createElement('div');
                svgContainer.innerHTML = svgData;
                const svgElem = svgContainer.querySelector('svg');

                // got our svg element.  Stet the children and attributes with those of this element
                while (this.firstChild) {
                    const child = this.firstChild;
                    const svgChild = document.createElementNS('http://www.w3.org/2000/svg', child.tagName);
                    svgElem.appendChild(svgChild);
                    svgChild.outerHTML = child.outerHTML;
                    this.removeChild(child);
                }

                for (let i = 0; i < this.attributes.length; i++) {
                    const attr = this.attributes[i];
                    if (attr.name === 'viewbox') {
                        svgElem.setAttributeNS('viewBox', attr.value);
                    } else {
                        svgElem.attributes.setNamedItem(attr.cloneNode());
                    }
                }

                // apply styles
                for (let i = this.style.length - 1; i >= 0; i--) {
                    const style = this.style[i];
                    svgElem.style[style] = this.style[style];

                }

                // now replace this with our new svg element
                if (!this.parentNode) {
                    return;      // detached while the fetch was in flight
                }
                this.parentNode.replaceChild(svgElem, this);
            }).catch(error => {
                console.error('Error fetching SVG:', error);
            });

    }
}

customElements.define('vetology-svg', VetologySvg);